/*
 * @Author: Yongchao Wang
 * @Date: 2021-07-05 10:55:43
 * @LastEditors: Yu Wang
 * @LastEditTime: 2022-03-28 16:25:01
 */
import request from '@/utils/request';
// import mockData from './mock/init.json';

export function getJsonTemplate(data) { // 获取初始化templateJson
  // return Promise.resolve({ data: mockData, param: data });
  return request({
    url: '/mcc/jsonTemplate/init',
    method: 'POST',
    data: {
      ...data,
      // 3105AB测试  A方案删除内容
      // initTest: localStorage.getItem('storageUser') === 'AUser' ? 'A' : 'B',
      initTest: localStorage.getItem('abtestLowPrice') === 'SHOW' ? 'A' : 'B',
    },
  });
}

export function getPriceDetail(data) { // 获取清单接口
  return request({
    url: '/component/getPriceDetail',
    method: 'POST',
    data,
  });
}

// 更新templateJson 获取新旧templateJson
export function jsonTemplateUpdate(data) {
  // eslint-disable-next-line no-param-reassign
  data.mccInit.initTest = 'A';
  // data.mccInit.initTest = localStorage.getItem('storageUser') === 'BUser' ? 'B' : 'A';
  return request({
    url: '/mcc/jsonTemplate/update',
    method: 'POST',
    data: {
      ...data,
    },
  });
}

// 获取冰箱类型（长度）
export function installFridgeArkCount(data) {
  return request({
    url: '/component/installFridgeArk/count',
    method: 'POST',
    data,
  });
}

// 切换冰箱
export function installFridgeArkUpdate(data) {
  return request({
    url: '/component/installFridgeArk/update',
    method: 'PUT',
    data,
  });
}
